/* tslint:disable */
/* eslint-disable */
/**
 * Logistics
 * 物流管理用API
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateCheckoutRedelivery201ResponseAllOfData } from './CreateCheckoutRedelivery201ResponseAllOfData';
import {
    CreateCheckoutRedelivery201ResponseAllOfDataFromJSON,
    CreateCheckoutRedelivery201ResponseAllOfDataFromJSONTyped,
    CreateCheckoutRedelivery201ResponseAllOfDataToJSON,
} from './CreateCheckoutRedelivery201ResponseAllOfData';

/**
 * 
 * @export
 * @interface CreateCheckoutRedelivery201Response
 */
export interface CreateCheckoutRedelivery201Response {
    /**
     * 
     * @type {CreateCheckoutRedelivery201ResponseAllOfData}
     * @memberof CreateCheckoutRedelivery201Response
     */
    data: CreateCheckoutRedelivery201ResponseAllOfData;
    /**
     * 
     * @type {object}
     * @memberof CreateCheckoutRedelivery201Response
     */
    meta: object;
}

/**
 * Check if a given object implements the CreateCheckoutRedelivery201Response interface.
 */
export function instanceOfCreateCheckoutRedelivery201Response(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "meta" in value;

    return isInstance;
}

export function CreateCheckoutRedelivery201ResponseFromJSON(json: any): CreateCheckoutRedelivery201Response {
    return CreateCheckoutRedelivery201ResponseFromJSONTyped(json, false);
}

export function CreateCheckoutRedelivery201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCheckoutRedelivery201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': CreateCheckoutRedelivery201ResponseAllOfDataFromJSON(json['data']),
        'meta': json['meta'],
    };
}

export function CreateCheckoutRedelivery201ResponseToJSON(value?: CreateCheckoutRedelivery201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateCheckoutRedelivery201ResponseAllOfDataToJSON(value.data),
        'meta': value.meta,
    };
}

